import styled from 'styled-components'

export const StyledMasthead = styled.div`
  position: relative;

  width: 100%;
  max-width: 550px;
  margin: 2rem auto;
`

export const Body = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  width: 100%;
  padding: 0 2rem;

  transform: translate(-50%, -50%);
`

export const Frame = styled.img`
  width: 100%;
  height: auto;
`

export const Leaves = styled.img`
  position: absolute;
  top: 2.25rem;
  left: 50%;
  display: block;

  width: 100%;
  max-width: 180px;
  height: auto;

  transform: translateX(-50%);
`

export const BottomLeaves = styled(Leaves)`
  top: initial;
  bottom: 2.25rem;
  transform: translateX(-50%) scaleY(-1);
`
